import React, { useCallback, useEffect, useRef, useState } from 'react';
import uploadSvg from '../../../../assets/img/upload.svg';
import sendSvg from '../../../../assets/img/send.svg';
import ScheduleMessagePicker from '../../../../components/ScheduleMessagePicker';
import ScheduledMessagesList, { fmtScheduledTimeLabel } from '../../../../components/ScheduledMessagesList';
import SidebarModal from '../../../../components/SidebarModal';
import addIcon from '../../../../assets/img/add.svg';
import arrowRightIcon from '../../../../assets/img/bi-arrow-right.svg';
import deleteBtn from '../../../../assets/img/delete.svg';
import feedbackReview from '../../../../assets/img/starbg.svg';
import filePic from '../../../../assets/img/file-picture.svg';
import APIServices from '../../../../services/APIServices';
import SignOffForm from '../../forms/SignOffForm';
import { MentionsInput, Mention } from 'react-mentions';
import {
  calculateDateDifference,
  formatDate,
  formatDateTime,
  hasPermission,
  renderHighlightedMessage,
  selectLoader
} from '../../../../utils/Helpers';
import { useAuth } from '../../../../contexts/AuthContext';
import { useStore } from '../../../../hooks/useStore';
import SignatureModal from '../../updatedOverviewModals/SignatureModal';
import ModalCenter from '../../../../components/ModalCenter';
import FeedbackModal from '../../updatedOverviewModals/FeedbackModal';
import appToast, { TOAST_TYPE } from '../../../../utils/AppToast';
import timerIcon from '../../../../assets/img/timer.svg';
import nickUser2 from '../../../../assets/img/nick-user2.png';
import timerRedIcon from '../../../../assets/img/timerred.svg';
import infoIcon from '../../../../assets/img/info.svg';
import AddQuoteModal from '../../updatedOverviewModals/AddQuoteModal';
import ChangeOrderModal from '../../updatedOverviewModals/ChangeOrderModal';
import ConfirmModal from '../../../../components/ConfirmModal';
import closeIcon from '../../../../assets/img/close.svg';
import fileImg from '../../../../assets/img/file.svg';
import fileIcon from '../../../../assets/img/file-picture.svg';
import RequestModal from '../../updatedOverviewModals/RequestModal';
import { fetchProjectTeamMembers } from '../../../../utils/fetchData';
import OverrideModal from 'pages/projects/updatedOverviewModals/OverrideModal';

import contractReference from '../../../../assets/img/contract-reference-icon.svg';
import { fetchEnumOptions } from 'pages/projects/kanban/utils/fetchData';
import RejectRequestModal from 'pages/projects/updatedOverviewModals/RejectRequestModal';
import { useNavigate } from 'react-router-dom';

const REQUEST_MESSAGE_PAGE_LIMIT = 10;

const RequestDetails = ({
  currentTab,
  selectedReqId,
  requestId,
  parentId,
  setActiveTab,
  setUpdateDetails,
  memberPermission,
  userRole,
  setCurrentTab,
  setSelectedReqId,
  isInternalProject,
  projectTeam
}) => {
  // console.log(selectedReqId);
  const navigate = useNavigate();
  const selectedReqIdRef = useRef(selectedReqId);
  const scrollRef = useRef(null);
  const [store, setStore] = useStore();
  const [userId, setUserId] = useState('');
  const [orderQouteId, setOrderQouteId] = useState(null);
  const [isQouted, setQouted] = useState(false);
  const [isQouteApproval, setQouteApproval] = useState(false);
  const [isQouteRequired, setQouteRequired] = useState(false);
  const [optionId, setOptionId] = useState('');
  const [changeReqId, setChangeReqId] = useState('');
  const [qouteId, setQouteId] = useState('');
  const [isEditable, setIsEditable] = useState(true);
  const [editableRequest, setEditableRequest] = useState(null);
  const [isFeedbackReq, setIsFeedbackReq] = useState(false);
  const [projectId, setProjectId] = useState('');
  const [requestData, setRequestData] = useState(null);
  const [milestoneId, setMilestoneId] = useState('');
  const [requestMsgId, setRequestMsgId] = useState('');
  const [loading, setLoading] = useState(false);
  const [requestDetailsError, setRequestDetailsError] = useState('');
  const [messagePageLoading, setMessagePageLoading] = useState(false);
  const [currentMessagePage, setCurrentMessagePage] = useState(1);
  const hasMoreMessagesRef = useRef(true);
  const messagePaginationInProgressRef = useRef(false);
  const requestDetailsSequenceRef = useRef(0);
  const skipMessageAutoScrollRef = useRef(false);
  const [attachments, setAttachments] = useState([]);
  const attachmentsRef = useRef([]);
  const [message, setMessage] = useState('');
  const [messageLoader, setMessageLoader] = useState(false);
  const messageSubmissionInProgressRef = useRef(false);
  const requestStatusUpdateInProgressRef = useRef(false);
  const [scheduledAt, setScheduledAt] = useState('');
  const [lastScheduledLabel, setLastScheduledLabel] = useState('');
  const [showScheduledList, setShowScheduledList] = useState(false);
  const [scheduledCount, setScheduledCount] = useState(0);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const downloadInProgressRef = useRef(false);
  const { isUser1, user, socket } = useAuth();
  const [mentionUsers, setMentionUsers] = useState([]);
  const [currentTime, setCurrentTime] = useState(Date.now());
  const [isRejecting, setRejecting] = useState(false);
  const [scopeExplanation, setScopeExplanation] = useState(
    'This request may be considered out of scope. Please ensure it aligns with supported request types before submitting.'
  );
  const [modals, setModals] = useState({
    convertConfirmModal: false,
    closeConfirmModal: false,
    cancelConfirmModal: false,
    addQuoteModal: false,
    signature: false,
    feedbackModal: false,
    changeOrderModal: false,
    requestModal: false,
    overrideModal: false
  });
  const [overrideReasons, setOverrideReasons] = useState([]);
  // console.log(selectedReqId);

  useEffect(() => {
    return () => {
      attachmentsRef.current.forEach(({ previewUrl }) => {
        if (previewUrl) URL.revokeObjectURL(previewUrl);
      });
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date()); // triggers re-render
    }, 60000); // every 1 minute

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (store.projectId) {
      setProjectId(store.projectId);
    }
  }, [store.projectId]);

  useEffect(() => {
    if (selectedReqId && currentTab == 2) {
      selectedReqIdRef.current = selectedReqId;
      console.log(selectedReqId);

      fetchRequestDetails();
    }
  }, [selectedReqId]);

  useEffect(() => {
    fetchOverrideReasons();
  }, []);

  const fetchOverrideReasons = async () => {
    try {
      const response = await fetchEnumOptions('override_reason');
      if (response.length > 0) {
        const optionsData = response.filter((item) => item.isActive);
        setOverrideReasons(optionsData);
        console.log(optionsData);
      }
    } catch (error) {
      console.error('Error fetching status options:', error);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      setUserId(user._id);
    }
  }, [user]);

  useEffect(() => {
    if (projectId) {
      fetchTeamMembers();
    }
  }, [projectId]);

  const fetchScheduledCount = useCallback(async () => {
    const reqId = selectedReqId || parentId || requestId;
    if (!projectId || !reqId) return;
    try {
      const res = await APIServices.get(`/scheduled-messages?projectId=${projectId}&requestId=${reqId}&type=request_message`);
      setScheduledCount(Array.isArray(res) ? res.length : 0);
    } catch {}
  }, [projectId, selectedReqId, parentId, requestId]);

  useEffect(() => {
    fetchScheduledCount();
  }, [fetchScheduledCount]);

  //this functiion will fetch the list of users for the mentions in chat
  const fetchTeamMembers = async () => {
    let members = await fetchProjectTeamMembers(projectId, undefined, '');
    let membersWithoutUser = members?.filter((x) => x.value != user?._id);
    const formattedMembers = membersWithoutUser?.map((member) => ({
      id: member.value,
      display: member.label,
      avatar: member.profilePic || nickUser2
    }));
    setMentionUsers(formattedMembers);
    // console.log(formattedMembers);
  };

  // Fetch details of the specific request
  const fetchRequestDetails = async (page = 1) => {
    const currentId = selectedReqIdRef.current || parentId || requestId;
    const isPaginationRequest = page > 1;

    if (isPaginationRequest && (!hasMoreMessagesRef.current || messagePaginationInProgressRef.current)) return;

    if (isPaginationRequest) {
      messagePaginationInProgressRef.current = true;
      setMessagePageLoading(true);
    } else {
      requestDetailsSequenceRef.current += 1;
      messagePaginationInProgressRef.current = false;
      setRequestDetailsError('');
      setRequestData(null);
      setEditableRequest(null);
      setLoading(true);
    }

    const requestSequence = requestDetailsSequenceRef.current;

    try {
      if (!currentId) {
        return;
      }
      // console.log(selectedReqId);

      const response = await APIServices.get(
        `/project-requests/message/${currentId}?page=${page}&limit=${REQUEST_MESSAGE_PAGE_LIMIT}`
      );

      if (response?.status >= 400 || !Array.isArray(response?.data)) {
        throw new Error(response?.data?.message || 'Failed to load request details.');
      }

      if (requestSequence === requestDetailsSequenceRef.current && Array.isArray(response.data)) {
        const messagePageData = response.data.filter((item) => !item?.isRequest);
        const pageData = isPaginationRequest ? messagePageData : response.data;

        if (isPaginationRequest) {
          skipMessageAutoScrollRef.current = true;
          setRequestData((previousData) => [...(previousData || []), ...pageData]);
        } else {
          setRequestData(pageData);
        }

        setCurrentMessagePage(page);
        const moreMessages =
          response.totalPages !== undefined
            ? page < response.totalPages
            : messagePageData.length === REQUEST_MESSAGE_PAGE_LIMIT;
        hasMoreMessagesRef.current = moreMessages;

        if (isPaginationRequest) return;

        if (response?.data[0]?.change_order_id) {
          setOrderQouteId(response.data[0].change_order_id);
        }
        let editableRequest = response.data.find((x) => !x.isEdited);
        let approvedQoute = response.data.find((x) => x?.message_type_id?.status == 'approved');
        console.log(approvedQoute, 'approvedQoute');

        if (editableRequest) {
          setEditableRequest(editableRequest);
        }
        if (approvedQoute) {
          setQouteId(approvedQoute.message_type_id._id);
        }

        setQouted(response.data[0]?.isQuoted);
      }
    } catch (err) {
      console.error(err);
      if (requestSequence === requestDetailsSequenceRef.current) {
        if (isPaginationRequest) {
          appToast('Failed to load more request messages. Please try again.', TOAST_TYPE.ERROR);
        } else {
          setRequestDetailsError(err?.message || 'Failed to load request details.');
        }
      }
    } finally {
      if (isPaginationRequest) {
        messagePaginationInProgressRef.current = false;
      }

      if (requestSequence === requestDetailsSequenceRef.current) {
        setLoading(false);
        setMessagePageLoading(false);
      }
    }
  };

  useEffect(() => {
    if (editableRequest) {
      // console.log(editableRequest);

      // setEditableRequest(editableRequest);
      // console.log(editableRequest?.milestoneId?._id);

      setMilestoneId(editableRequest?.milestoneId?._id);
      setRequestMsgId(editableRequest?._id);
      if (editableRequest.approverSign || editableRequest.status === 'close') {
        setIsEditable(false);
      } else {
        setIsEditable(true);
      }
      setIsFeedbackReq(editableRequest?.milestoneId?.feedbackRequest);
    }
  }, [editableRequest]);

  useEffect(() => {
    if (!requestId) return;
    fetchRequestDetails();
  }, [requestId]);

  useEffect(() => {
    return () => {
      console.log('requestdetails usefccet');
      setSelectedReqId('');
      setIsFeedbackReq(false);
    };
  }, []);

  const toggleModal = (modalType, isOpen) => {
    setModals((prevState) => ({
      ...prevState,
      [modalType]: isOpen
    }));
  };

  const updateCloseModal = (modalName) => {
    toggleModal(modalName, false);
    setQouteId('');
    setQouteApproval(false);
    fetchRequestDetails();
    setUpdateDetails();
    if (modalName == 'feedbackModal') {
      console.log('requestdetails usefccet 2');
      setSelectedReqId('');
      setStore({ feedbackTab: 'given' });
      setCurrentTab(4);
    }
    //this is to change the tab of overview tabs
    // setCurrentTab(1);
  };

  const formatScheduledAt = (val) => {
    if (!val) return '';
    const d = new Date(val);
    return d.toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' });
  };

  // Function to handle file uploads
  const handleFileUpload = (event) => {
    // console.log(event, 'clickeddd');

    const files = Array.from(event.target.files);
    const newAttachments = files.map((file) => ({
      file,
      previewUrl: file.type.startsWith('image/') ? URL.createObjectURL(file) : null
    }));

    setAttachments((prevAttachments) => {
      const nextAttachments = [...prevAttachments, ...newAttachments];
      attachmentsRef.current = nextAttachments;
      return nextAttachments;
    });
    if (event.target) event.target.value = '';
  };

  // Function to remove an attachment
  const removeAttachment = (index) => {
    setAttachments((prevAttachments) => {
      const removedAttachment = prevAttachments[index];
      if (removedAttachment?.previewUrl) URL.revokeObjectURL(removedAttachment.previewUrl);

      const nextAttachments = prevAttachments.filter((_, i) => i !== index);
      attachmentsRef.current = nextAttachments;
      return nextAttachments;
    });
  };

  // Function to handle sending the message
  const handleSendMessage = async () => {
    if (messageSubmissionInProgressRef.current) return;

    if ((!message || message.trim() === '') && attachments.length === 0) {
      appToast('Please enter a message or attachment to send.', TOAST_TYPE.ERROR);
      return;
    }

    messageSubmissionInProgressRef.current = true;
    setMessageLoader(true);
    const formData = new FormData();
    const messageUserTags = [];
    const regex = /@\[([^\]]+)\]\(([^)]+)\)/g;
    let processedMessage = message;
    let match;
    while ((match = regex.exec(message)) !== null) {
      const tagname = match[1];
      const userId = match[2];
      messageUserTags.push({ tagname, userId });
      processedMessage = processedMessage.replace(match[0], `@${tagname} `);
    }

    attachments.forEach(({ file }) => formData.append('attachments', file));
    formData.append('message', processedMessage);
    formData.append('projectId', projectId);
    formData.append('message_user_tags', JSON.stringify(messageUserTags));
    if (milestoneId) formData.append('milestoneId', milestoneId);
    const reqId = selectedReqId || parentId || requestId;
    if (reqId) formData.append('requestId', reqId);
    formData.append('message_type', 'text');

    try {
      if (scheduledAt) {
        formData.append('type', 'request_message');
        formData.append('scheduledAt', scheduledAt);
        await APIServices.post('/scheduled-messages', formData, { 'Content-Type': 'multipart/form-data' });
        appToast(`Message scheduled for ${formatScheduledAt(scheduledAt)}`, TOAST_TYPE.SUCCESS);
        setLastScheduledLabel(fmtScheduledTimeLabel(scheduledAt));
        setScheduledAt('');
        fetchScheduledCount();
      } else {
        await APIServices.post('/project-requests/message', formData, { 'Content-Type': 'multipart/form-data' });
      }
      setMessage('');
      attachments.forEach(({ previewUrl }) => {
        if (previewUrl) URL.revokeObjectURL(previewUrl);
      });
      attachmentsRef.current = [];
      setAttachments([]);
    } catch (error) {
      console.error('Error sending message:', error);
      appToast('Failed to send message. Please try again.', TOAST_TYPE.ERROR);
    } finally {
      messageSubmissionInProgressRef.current = false;
      setMessageLoader(false);
    }
  };

  const editQoute = (id) => {
    const currentId = orderQouteId || selectedReqId || parentId || requestId;

    window.open(
      `${window.location.origin}/#/change-order/${requestMsgId}?projectId=${projectId}&changeReqId=${currentId}&qouteId=${id}&isEditQuoteFlow=true`,
      '_blank'
    );
  };

  const handleApproveOpen = (qouteId) => {
    setQouteApproval(true);
    setQouteId(qouteId);
    if (optionId == '' || !optionId) {
      appToast('Please select an option from Qoute first.', TOAST_TYPE.ERROR);
      return;
    }
    toggleModal('signature', true);
  };

  const handleDownloadPdf = async () => {
    if (downloadInProgressRef.current) return;

    downloadInProgressRef.current = true;
    try {
      setDownloadLoader(true);
      const response = await APIServices.get(`/project-request-quote/download/${qouteId}`);

      if (response?.status >= 400 || !response?.data?.downloadUrl) {
        throw new Error(response?.data?.message || 'Failed to download the PDF.');
      }

      if (response.data.downloadUrl) {
        const { downloadUrl } = response.data;

        // Create a temporary anchor element
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.target = '_blank'; // Optional: Open in a new tab
        link.download = 'quote.pdf'; // Optional: Suggest a filename for the download

        // Append the link to the body and trigger the download
        document.body.appendChild(link);
        link.click();

        // Clean up the DOM
        document.body.removeChild(link);
      }
    } catch (err) {
      console.error(err);
      appToast(err?.message || 'Failed to download the PDF. Please try again.', TOAST_TYPE.ERROR);
    } finally {
      downloadInProgressRef.current = false;
      setDownloadLoader(false);
      // setQouteId('');
    }
  };

  const handleFeedbackModal = () => {
    if (isFeedbackReq) {
      toggleModal('signature', false);
      toggleModal('feedbackModal', true);
    } else {
      updateCloseModal('signature');
    }
  };

  const handleCloseReq = async (isCanceled = true) => {
    if (requestStatusUpdateInProgressRef.current) return;

    requestStatusUpdateInProgressRef.current = true;
    setLoading(true);

    try {
      const response = await APIServices.put(`/project-requests/${requestMsgId}/update-status`, {
        status: isRejecting ? 'rejected' : 'closed',
        isCanceled: isCanceled
      });
      if (response.message) {
        appToast(response.message, TOAST_TYPE.SUCCESS);

        setUpdateDetails();
        fetchRequestDetails();
      } else if (response.data.message) {
        appToast(response.data.message, TOAST_TYPE.ERROR);
      }
    } catch (error) {
      // Handle errors
      appToast(error, TOAST_TYPE.ERROR);
    } finally {
      toggleModal('cancelConfirmModal', false);
      toggleModal('closeConfirmModal', false);
      requestStatusUpdateInProgressRef.current = false;
      setLoading(false); // Reset the submitting state
    }
  };

  const handleCovertReq = async () => {
    if (requestStatusUpdateInProgressRef.current) return;

    requestStatusUpdateInProgressRef.current = true;
    setLoading(true);

    try {
      const response = await APIServices.put(`/project-requests/convert/${requestMsgId}/changeorder`);
      if (response.message) {
        appToast(response.message, TOAST_TYPE.SUCCESS);
        toggleModal('convertConfirmModal', false);
        fetchRequestDetails();
      } else if (response.data.message) {
        appToast(response.data.message, TOAST_TYPE.ERROR);
      }
    } catch (error) {
      // Handle errors
      appToast(error, TOAST_TYPE.ERROR);
    } finally {
      requestStatusUpdateInProgressRef.current = false;
      setLoading(false); // Reset the submitting state
    }
  };

  let handleAddQoute = () => {
    const currentId = orderQouteId || selectedReqId || parentId || requestId;

    window.open(
      `${window.location.origin}/#/change-order/${requestMsgId}?projectId=${projectId}&changeReqId=${currentId}&isAddQuoteFlow=true`,
      '_blank'
    );
  };

  const closeConfirmContent = (
    <div>
      <h2 className="mb-3">Are you sure?</h2>
      <h3>You want to {isRejecting ? 'reject' : 'close'} this request? </h3>
    </div>
  );

  const cancelConfirmContent = (
    <div>
      <h2 className="mb-3">Are you sure?</h2>
      <h3>You want to cancel this request? </h3>
    </div>
  );

  const convertConfirmContent = (
    <div>
      <h2 className="mb-3">Are you sure?</h2>
      <h3>Do you want to convert this request? </h3>
    </div>
  );

  // Scroll to the bottom whenever requests change
  useEffect(() => {
    if (skipMessageAutoScrollRef.current) {
      skipMessageAutoScrollRef.current = false;
      return;
    }

    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [requestData]);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    const handleMessageScroll = () => {
      const isAtBottom =
        Math.abs(scrollContainer.scrollHeight - scrollContainer.scrollTop - scrollContainer.clientHeight) <= 2;

      if (
        isAtBottom &&
        currentTab === 2 &&
        hasMoreMessagesRef.current &&
        !messagePaginationInProgressRef.current
      ) {
        fetchRequestDetails(currentMessagePage + 1);
      }
    };

    scrollContainer.addEventListener('scroll', handleMessageScroll);
    return () => scrollContainer.removeEventListener('scroll', handleMessageScroll);
  }, [currentMessagePage, currentTab]);

  useEffect(() => {
    // Listen for 'projectActivityUpdate' event
    const activeRequestId = selectedReqId || parentId || requestId;
    if (!socket || !activeRequestId || currentTab !== 2) return;

    const normalizeId = (value) => (value?._id || value)?.toString();
    const normalizedActiveRequestId = normalizeId(activeRequestId);

    const handleRequestMessage = (activity) => {
      if (normalizeId(activity?.requestId) !== normalizedActiveRequestId) return;

      setRequestData((previousData) => [...(previousData || []), activity]);
      if (activity?.message_type !== 'text' && !loading) {
        fetchRequestDetails();
      }
    };

    const handleProjectRequestClosed = (activity) => {
      const closedRequestId = normalizeId(activity?.requestId || activity?._id);
      if (closedRequestId !== normalizedActiveRequestId) return;

      setRequestData((previousData) => [...(previousData || []), activity]);
    };

    socket.on('RequestMessage', handleRequestMessage);
    socket.on('ProjectRequestClosed', handleProjectRequestClosed);

    return () => {
      socket.off('RequestMessage', handleRequestMessage);
      socket.off('ProjectRequestClosed', handleProjectRequestClosed);
    };
  }, [socket, currentTab, selectedReqId, parentId, requestId]);

  return (
    <div className="card-body-content" ref={scrollRef}>
      <div className="user-chatBox-cover">
        <ul className="chat-btn-list">
          {/* <li>
            <a
              className="cursor_pointer"
              style={{ width: 'fitContent', minWidth: '10px' }}
              onClick={() => toggleModal('feedbackModal', true)}>
              feedbackModal
            </a>
          
          </li> */}

          {isEditable &&
            editableRequest?.requestType == 'sign_off' &&
            !editableRequest.isCanceled &&
            hasPermission(userRole, 'send_signoff_requests', memberPermission) && (
              <li>
                <a
                  className="cursor_pointer"
                  style={{ width: 'fitContent', minWidth: '10px' }}
                  onClick={() => toggleModal('signOffModal', true)}>
                  Edit
                </a>
              </li>
            )}

          {editableRequest?.requestType == 'sign_off' &&
            userId == editableRequest.createdBy?._id &&
            editableRequest.status != 'close' &&
            !editableRequest.isCanceled && (
              <li>
                <a
                  className="cursor_pointer"
                  style={{ width: 'fitContent', minWidth: '10px' }}
                  onClick={() => toggleModal('cancelConfirmModal', true)}>
                  Cancel
                </a>
              </li>
            )}

          {isEditable &&
            editableRequest?.requestType == 'sign_off' &&
            (hasPermission(userRole, 'approve_sign_off', memberPermission, isInternalProject) ||
              editableRequest?.requestRecipients?.includes(user?._id)) && (
              <li>
                <a
                  className="cursor_pointer"
                  style={{ width: 'fitContent', minWidth: '10px' }}
                  onClick={() => toggleModal('signature', true)}>
                  Approve and Sign
                </a>
              </li>
            )}
          {/* have to add the conditional renderings for this part */}
          {editableRequest?.requestType == 'change_order' &&
            hasPermission(userRole, 'change_order', memberPermission) &&
            userId == editableRequest.createdBy?._id &&
            editableRequest.status != 'close' &&
            !editableRequest.isCanceled && (
              <>
                <li>
                  <a
                    className="cursor_pointer"
                    style={{ width: 'fitContent', minWidth: '10px' }}
                    onClick={() => toggleModal('changeOrderModal', true)}>
                    Edit
                  </a>
                </li>

                <li>
                  <a
                    className="cursor_pointer"
                    style={{ width: 'fitContent', minWidth: '10px' }}
                    onClick={() => toggleModal('closeConfirmModal', true)}>
                    Close
                  </a>
                </li>
              </>
            )}

          {editableRequest?.requestType == 'change_order' &&
          hasPermission(userRole, 'change_order', memberPermission) ? (
            editableRequest.status == 'close' && !editableRequest.isCanceled && editableRequest?.isQuoted && qouteId ? (
              <li>
                <a
                  className="cursor_pointer"
                  style={{ width: 'fitContent', minWidth: '100px' }}
                  onClick={() => handleDownloadPdf()}>
                  {downloadLoader ? selectLoader(15, 2) : 'Download PDF'}
                </a>
              </li>
            ) : (
              editableRequest.status != 'close' &&
              !isQouted &&
              hasPermission(userRole, 'add_qoute', memberPermission) &&
              !editableRequest.isCanceled && (
                <li>
                  <a
                    className="cursor_pointer"
                    style={{ width: 'fitContent', minWidth: '10px' }}
                    // onClick={() => toggleModal('addQuoteModal', true)}
                    onClick={() => handleAddQoute()}>
                    + Add Qoute
                  </a>
                </li>
              )
            )
          ) : (
            ''
          )}
          {editableRequest?.requestType == 'change_request' &&
            hasPermission(userRole, 'change_request', memberPermission) &&
            editableRequest.status != 'close' &&
            !editableRequest.isCanceled && (
              <>
                {/* {isUser1 &&
                  editableRequest?.scopeReview?.scopeStatus &&
                  editableRequest?.workflowState === 'REJECTED' && (
                    <li>
                      <a
                        className="cursor_pointer"
                        style={{ width: 'fitContent', minWidth: '10px' }}
                        onClick={() => toggleModal('closeConfirmModal', true)}>
                        Close
                      </a>
                    </li>
                  )} */}
                {userId == editableRequest.createdBy?._id &&
                  editableRequest?.workflowState !== 'REJECTED' &&
                  editableRequest?.workflowState !== 'OVERRIDDEN' && (
                    <li>
                      <a
                        className="cursor_pointer"
                        style={{ width: 'fitContent', minWidth: '10px' }}
                        onClick={() => toggleModal('requestModal', true)}>
                        Edit
                      </a>
                    </li>
                  )}
                {hasPermission(userRole, 'close_req', memberPermission) &&
                  editableRequest?.workflowState !== 'REJECTED' && (
                    <li>
                      <a
                        className="cursor_pointer"
                        style={{ width: 'fitContent', minWidth: '10px' }}
                        // onClick={() => appToast('Coming soon...', TOAST_TYPE.WARNING)}
                        onClick={() => toggleModal('convertConfirmModal', true)}>
                        {editableRequest?.workflowState !== 'OVERRIDDEN' &&
                        editableRequest?.scopeReview?.scopeStatus != 'IN_SCOPE'
                          ? 'Create '
                          : 'Convert to '}
                        Change Order
                      </a>
                    </li>
                  )}
                {(hasPermission(userRole, 'close_req', memberPermission) || userId == editableRequest.createdBy?._id) &&
                  !editableRequest.isCanceled && (
                    <>
                      {/* <li>
                      <a
                        className="cursor_pointer"
                        style={{ width: "fitContent", minWidth: "10px" }}
                        onClick={() => toggleModal("cancelConfirmModal", true)}
                      >
                        Cancel
                      </a>
                    </li> */}
                      {isUser1 &&
                        (!editableRequest?.scopeReview?.scopeStatus ||
                          editableRequest?.workflowState === 'OVERRIDDEN') && (
                          <li>
                            <a
                              className="cursor_pointer"
                              style={{ width: 'fitContent', minWidth: '10px' }}
                              onClick={() => toggleModal('closeConfirmModal', true)}>
                              Close
                            </a>
                          </li>
                        )}
                      {isUser1 &&
                        editableRequest?.scopeReview?.scopeStatus &&
                        editableRequest?.scopeReview?.scopeStatus != 'IN_SCOPE' &&
                        editableRequest?.workflowState !== 'REJECTED' &&
                        editableRequest?.workflowState !== 'OVERRIDDEN' && (
                          <>
                            <li>
                              <a
                                className="cursor_pointer"
                                style={{ width: 'fitContent', minWidth: '10px' }}
                                onClick={() => {
                                  setRejecting(true);
                                  toggleModal('rejectReqModal', true);
                                }}>
                                Reject
                              </a>
                            </li>
                            <li>
                              <a
                                className="cursor_pointer"
                                style={{ width: 'fitContent', minWidth: '10px' }}
                                onClick={() => toggleModal('overrideModal', true)}>
                                Override
                              </a>
                            </li>
                          </>
                        )}
                    </>
                  )}
              </>
            )}

          {(editableRequest?.requestType == 'change_order' || editableRequest?.requestType == 'change_request') &&
            userId == editableRequest.createdBy?._id &&
            editableRequest.status != 'close' &&
            !editableRequest.isCanceled && (
              <li>
                <a
                  className="cursor_pointer"
                  style={{ width: 'fitContent', minWidth: '10px' }}
                  onClick={() => toggleModal('cancelConfirmModal', true)}>
                  Cancel
                </a>
              </li>
            )}
        </ul>
        {editableRequest?.status == 'open' && (
          <div className="chat-msg-cover">
            <div className="upload-cover">
              {attachments.map(({ file, previewUrl }, index) => (
                <div className="upload-box" key={index}>
                  <img
                    src={closeIcon}
                    className="closeicon"
                    onClick={() => removeAttachment(index)}
                    alt="Remove attachment"
                  />
                  <img
                    src={previewUrl || fileImg}
                    className="fileimg"
                    alt={file.name}
                  />
                  <div className="upload-text">
                    <p>{file.name}</p>
                    <span>{(file.size / 1024).toFixed(2)} KB</span>
                  </div>
                </div>
              ))}
            </div>
            {scheduledAt && (
              <div className="schedule-info-bar">
                <span>⏰ Sending at {formatScheduledAt(scheduledAt)}</span>
                <img src={closeIcon} className="schedule-clear-icon cursor_pointer" alt="Clear" onClick={() => setScheduledAt('')} />
              </div>
            )}
            {!scheduledAt && lastScheduledLabel && (
              <div className="schedule-info-bar schedule-info-bar--confirm">
                <span>⏰ Your message will be sent {lastScheduledLabel}.</span>
                <span className="schedule-see-all cursor_pointer" onClick={() => setShowScheduledList(true)}>See all scheduled messages</span>
              </div>
            )}
            {scheduledCount > 0 && !lastScheduledLabel && (
              <div className="schedule-pending-bar" onClick={() => setShowScheduledList(true)}>
                <span>⏰ {scheduledCount} scheduled message{scheduledCount > 1 ? 's' : ''}</span>
                <span className="schedule-pending-bar__view">View all →</span>
              </div>
            )}
            <ScheduledMessagesList
              projectId={projectId}
              requestId={selectedReqId || parentId || requestId}
              type="request_message"
              show={showScheduledList}
              onClose={() => { setShowScheduledList(false); fetchScheduledCount(); }}
              onMessagesChange={(messages) => {
                setScheduledCount(messages.length);
                if (messages.length === 0) setLastScheduledLabel('');
              }}
            />
            <div className="send-msg-text">
              <label htmlFor="fileUpload">
                <img src={uploadSvg} className="upload-icon cursor_pointer" alt="Upload" />
              </label>
              <input
                id="fileUpload"
                type="file"
                accept="image/*"
                style={{ display: 'none' }}
                multiple
                onChange={handleFileUpload}
              />
              {/* Mentions Input */}
              <div style={{ position: 'relative', flex: 1 }}>
                <MentionsInput
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  className="formControl"
                  placeholder="Type your message..."
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && !e.shiftKey) {
                      e.preventDefault();
                      handleSendMessage();
                    }
                  }}>
                  <Mention
                    trigger="@"
                    data={mentionUsers}
                    displayTransform={(id, display) => `@${display} `}
                    renderSuggestion={(suggestion) => (
                      <>
                        <img src={suggestion.avatar} alt="nickUser2" className="nickUser" />
                        <p>{suggestion.display}</p>
                      </>
                    )}
                  />
                </MentionsInput>
              </div>
              {/* Send / Schedule Button */}
              <div className="send-msg-split">
                <div
                  className={`send-msg-cover ${scheduledAt ? 'send-msg-cover--scheduled' : ''}`}
                  onClick={handleSendMessage}>
                  {messageLoader ? selectLoader(15) : <img src={sendSvg} alt="Send" />}
                </div>
                <ScheduleMessagePicker onSchedule={(iso) => setScheduledAt(iso)} />
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="request_details_page request_details_page_main">
        {loading ? (
          <div>{selectLoader(50)}</div>
        ) : requestDetailsError ? (
          <div className="nodata-loader h-100">
            <p className="error-message">{requestDetailsError}</p>
            <button type="button" className="btn-black" onClick={() => fetchRequestDetails(1)}>
              Retry
            </button>
          </div>
        ) : (
          requestData &&
          requestData.length > 0 && (
            <>
              {requestData.map((request) => (
                <>
                  <div>
                    {request?.message_type == 'reject' && (
                      <div className={`wire-frame_design   `} key={request._id}>
                        <div className="request_header_inner ">
                          <div>
                            <span className="rejected-text">Rejected:</span>{' '}
                            <span className="rejected-title">{request.requestTitle}</span>
                          </div>
                          <p className="override-note">{request?.rejectionReason}</p>
                        </div>
                      </div>
                    )}
                    {request?.message_type == 'override' && (
                      <div className={`wire-frame_design   `} key={request._id}>
                        <div className="request_header_inner ">
                          <p className={`override-header-text`}>Overridden</p>
                          <div className="header-left-text">
                            {request?.overrideMeta?.reasons?.map((reason, index) => (
                              <>
                                <p key={reason._id}>{reason.name}</p>
                                {index < request?.overrideMeta?.reasons.length - 1 && <span>&nbsp;</span>}
                              </>
                            ))}
                          </div>
                          <p className="override-note">{request?.overrideMeta?.note}</p>
                        </div>
                      </div>
                    )}
                    {(request?.message_type == 'text' || request?.message_type == 'close') && (
                      <div
                        className={`wire-frame_design   ${
                          userId == request.createdBy?._id ? 'text-bubble-me' : 'text-bubble-you'
                        }`}
                        key={request._id}>
                        <div className="request_header_inner ">
                          <p
                            className={`${request?.message_type == 'close' ? 'lightblue-text' : ''}`}
                            dangerouslySetInnerHTML={{
                              __html: renderHighlightedMessage(request)
                            }}>
                            {/* Hey <b className="lightblue-text">@Ravi,</b> */}
                            {/* {request.message} */}
                          </p>
                        </div>
                        <div className="file_uploaded_inner">
                          {request.attachments.length > 0 &&
                            request.attachments.map((file, index) => (
                              <div className="file_item" key={index}>
                                <a href={file.url} target="_blank" className="attachment-tag">
                                  <img src={fileIcon} />
                                  <div className="file_name">
                                    <h6>{file.name}</h6>
                                    <span className="file_size">{file?.size}</span>
                                  </div>
                                </a>
                              </div>
                            ))}
                        </div>
                      </div>
                    )}
                    {request.requestType == 'sign_off' && (
                      <div className={`wire-frame_design  ${request.isEdited ? 'opacity50' : ''}`} key={request._id}>
                        <div className="request_header_inner">
                          <div className="card_header request_card_header">
                          <label>
                            <b className="darkblue-text">Sign-off Request!</b> Milestone: {request?.milestoneId?.name}
                          </label>
                          {request.signoffType && <div className="card_header_btn-group">
                            <a className="card_btn">{request.signoffType == "internal" ? "Internal" : "External"}</a>
                          </div>}
                          </div>
                          <ul className="">
                            <li>
                              {' '}
                              <p>
                                Milestone status is:{' '}
                                <b className="text-green">
                                  {request?.isCanceled ? 'Cancelled' : request?.signoffStatus?.name}{' '}
                                </b>
                              </p>
                            </li>
                            {request?.description?.length > 0 && (
                              <li>
                                {' '}
                                <p>{request.description}</p>
                              </li>
                            )}
                          </ul>
                        </div>
                        <div className="file_uploaded_inner">
                          {request.attachments
                            ? request.attachments.map((attachment) => {
                                return (
                                  <div className="file_item" key={attachment._id}>
                                    <a href={attachment.url} target="_blank" className="attachment-tag">
                                      <img src={filePic} />
                                      <div className="file_name">
                                        <h6>{attachment.name}</h6>
                                        <span className="file_size">{attachment.size}</span>
                                      </div>
                                    </a>
                                  </div>
                                );
                              })
                            : ''}
                        </div>
                        <div className="request_footer_inner">
                          {request.approverSign && (
                            <div className="signed-div">
                              <button className={`edit-btn button-signed`}>Signed</button>
                              <img src={request.approverSign.url} />
                            </div>
                          )}
                        </div>
                        {!request.approverSign &&
                        !request.isEdited &&
                        request.requestType == 'sign_off' &&
                        request.signoffDeadline !== 0 ? (
                          <div className="request_time_content">
                            <div
                              className={`timer ${(() => {
                                const signoffDateDifference = calculateDateDifference(
                                  request.signoffDeadlineDate,
                                  currentTime,
                                  true
                                );
                                return signoffDateDifference.includes('Overdue') ? 'text-danger' : '';
                              })()}`}>
                              {(() => {
                                const signoffDateDifference = calculateDateDifference(
                                  request.signoffDeadlineDate,
                                  currentTime,
                                  true
                                );
                                const isOverdue = signoffDateDifference.includes('Overdue');

                                return (
                                  <>
                                    <img src={timerIcon} className="tiner_icon" />
                                    Due by {formatDate(request.signoffDeadlineDate || new Date(), true)} |{' '}
                                    {signoffDateDifference} {isOverdue ? '' : 'left'}
                                    <img src={infoIcon} className="info_icon" />
                                  </>
                                );
                              })()}
                            </div>
                            <p>
                              To ensure the project stays on track, any sign-off requests that remain unaddressed by the
                              specified deadline will result in an adjustment to the timeline, with the deadline
                              extended by the corresponding number of days.
                            </p>
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    )}
                    {request.requestType == 'change_request' && (
                      <div className={`wire-frame_design  ${request.isEdited ? 'opacity50' : ''}`} key={request._id}>
                        <div className="request_header_inner">
                          <div className="card_header request_card_header">
                            <label>
                              <b className="lightbluebg-text">Request!:</b> {request?.title}
                            </label>
                            {request?.scopeReview?.scopeStatus && request?.scopeReview?.scopeStatus != 'IN_SCOPE' && (
                              <div className="card_header_btn-group">
                                <a className="card_btn">Out of Scope</a>
                                {/* <a className="card_btn card_btn_green">Signed</a>
                                <a className="card_btn card_btn_red">Quote Declined</a> */}
                              </div>
                            )}
                          </div>
                          {request?.description?.length > 0 && (
                            <ul className="request-text-description">
                              <li>
                                {' '}
                                <p>{request.description}</p>
                              </li>
                            </ul>
                          )}
                        </div>
                        {request?.scopeReview?.scopeStatus && request?.scopeReview?.scopeStatus != 'IN_SCOPE' && (
                          <>
                            <div className="request-content-inner">
                              <label>Why</label>
                              <p>{request?.scopeReview?.reasoning}</p>
                            </div>
                            {request?.scopeReview?.referencedClauses?.length > 0 && (
                              <div className="request-content-inner">
                                <label>
                                  Contract Reference <img src={contractReference} className="contractReference" />
                                </label>
                                <p className="contract-text">
                                  {request?.scopeReview?.referencedClauses &&
                                  request?.scopeReview?.referencedClauses.length > 0
                                    ? request?.scopeReview?.referencedClauses.map((clause, index) => (
                                        <div key={index}>{clause}</div>
                                      ))
                                    : 'No specific contract clauses referenced.'}
                                </p>
                              </div>
                            )}
                          </>
                        )}
                        {request?.attachments?.length > 0 && <label className="attachments-label">Attachments</label>}
                        <div className="file_uploaded_inner">
                          {request.attachments && request?.attachments?.length > 0
                            ? request.attachments.map((attachment) => {
                                return (
                                  <div className="file_item" key={attachment._id}>
                                    <a href={attachment.url} target="_blank" className="attachment-tag">
                                      <img src={filePic} />
                                      <div className="file_name">
                                        <h6>{attachment.name}</h6>
                                        <span className="file_size">{attachment.size}</span>
                                      </div>
                                    </a>
                                  </div>
                                );
                              })
                            : ''}
                        </div>
                        <div className="request_footer_inner">
                          {request.approverSign && (
                            <div className="signed-div">
                              <button className={`edit-btn button-signed`}>Signed</button>
                              <img src={request.approverSign.url} />
                            </div>
                          )}
                        </div>
                        {!request.approverSign &&
                          !request.isEdited &&
                          request.status != 'close' &&
                          request?.changeRequestDeadline > 0 && (
                            <div className="request_time_content">
                              <div className="timer">
                                {(() => {
                                  const signoffDateDifference = calculateDateDifference(
                                    request.changeRequestDeadlineDate,
                                    currentTime,
                                    true
                                  );
                                  const isOverdue = signoffDateDifference.includes('Overdue');
                                  const changeRequestDateDifference = calculateDateDifference(
                                    request.changeRequestDeadlineDate,
                                    currentTime,
                                    true
                                  );

                                  return (
                                    <>
                                      <img src={isOverdue ? timerRedIcon : timerIcon} className="tiner_icon" />
                                      <span className={`${isOverdue ? 'text-danger' : ''}`}>
                                        Due by {formatDate(request.changeRequestDeadlineDate || new Date(), true)} |{' '}
                                        {changeRequestDateDifference} {isOverdue ? '' : 'left'}
                                      </span>
                                      <img src={infoIcon} className="info_icon" />
                                    </>
                                  );
                                })()}
                              </div>
                              <p>
                                Fulfilling these requests on time helps keep your project moving smoothly and on
                                schedule!
                              </p>
                              {request?.scopeEvaluation?.result === 'out_of_scope' && (
                                <div className="explaination-text mt-2 w-100" style={{ fontSize: '13px' }}>
                                  <span>
                                    <b>Important:</b> {request?.scopeEvaluation?.explanation}
                                  </span>
                                </div>
                              )}
                            </div>
                          )}
                      </div>
                    )}

                    {request.requestType == 'change_order' && (
                      <div className={`wire-frame_design  ${request.isEdited ? 'opacity50' : ''}`} key={request._id}>
                        <div className="request_header_inner">
                          <label>
                            <b className="darkblue-text">Change Order!</b> {request?.title}
                          </label>
                          <p>{request.description}</p>
                        </div>
                        <div className="file_uploaded_inner">
                          {request.attachments
                            ? request.attachments.map((attachment) => {
                                return (
                                  <div className="file_item" key={attachment._id}>
                                    <a href={attachment.url} target="_blank" className="attachment-tag">
                                      <img src={filePic} />
                                      <div className="file_name">
                                        <h6>{attachment.name}</h6>
                                        <span className="file_size">{attachment.size}</span>
                                      </div>
                                    </a>
                                  </div>
                                );
                              })
                            : ''}
                        </div>
                        <div className="request_footer_inner">
                          {request.approverSign && (
                            <div className="signed-div">
                              <button className={`edit-btn button-signed`}>Signed</button>
                              <img src={request.approverSign.url} />
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {request.message_type == 'ProjectRequestQuote' && (
                      <div
                        key={request._id}
                        className={`request_details_page request_details_page_main  ${
                          request?.message_type_id?.isEdited ||
                          (request?.message_type_id?.isAccepted && request?.message_type_id?.status === 'quote')
                            ? 'opacity50'
                            : ''
                        }`}>
                        <div className="request_content_cover additional_work_cls">
                          <div className="radio_btn_section">
                            <span className="quote-text">
                              {request.message_type_id?.approverSign && 'Approved'} Quote!
                            </span>
                            {request.message_type_id?.options?.map((option, index) => (
                              <div className="radio_inner_sec" key={option._id}>
                                {!(
                                  request?.message_type_id?.isAccepted && request?.message_type_id?.status === 'quote'
                                ) &&
                                  !request.message_type_id?.approverSign &&
                                  !request?.message_type_id?.isEdited &&
                                  hasPermission(userRole, 'approve_qoute', memberPermission, isInternalProject) && (
                                    <div className="radio_btn">
                                      <input
                                        type="radio"
                                        id={`option${index}`}
                                        name="radio-group"
                                        onClick={() => {
                                          setOptionId(option._id);
                                        }}
                                      />
                                      <label htmlFor={`option${index}`}></label>
                                    </div>
                                  )}
                                <div className="radio_btn_content">
                                  <div className="radio_head">
                                    <h4>{option.title}</h4>
                                    {/* <span>{option.numberOfDays} days</span> */}
                                    <img src={arrowRightIcon} alt="Arrow Icon" />
                                    <small>${option.additionalCost}</small>
                                  </div>
                                  <div className="radio_bottom_cont">
                                    <p>{option.description}</p>
                                    <ul className="line-items-quote">
                                      {option.lineItems.map((item) => (
                                        <li key={item.id}>{item.title}</li>
                                      ))}
                                    </ul>
                                    <p> Additional days: {option.numberOfDays}</p>
                                  </div>
                                </div>
                              </div>
                            ))}
                            <div className="request_footer_inner">
                              {request.message_type_id.approverSign && (
                                <div className="signed-div">
                                  <button className={`edit-btn button-signed`}>Signed</button>
                                  <img src={request.message_type_id.approverSign.url} />
                                </div>
                              )}
                            </div>
                            {editableRequest.status !== 'close' && (
                              <div className="qoute-footer">
                                <div className="request_time_content" style={{ maxWidth: '80%' }}>
                                  <span
                                    className={`timer text-left ${
                                      calculateDateDifference(
                                        request?.message_type_id?.expireInDate,
                                        currentTime,
                                        true
                                      ).includes('Overdue')
                                        ? 'text-danger'
                                        : ''
                                    }`}>
                                    {!(
                                      request?.message_type_id?.isAccepted &&
                                      request?.message_type_id?.status === 'quote'
                                    ) &&
                                    request?.message_type_id?.expireInDate &&
                                    !request.message_type_id?.approverSign
                                      ? calculateDateDifference(
                                          request?.message_type_id?.expireInDate,
                                          currentTime,
                                          true
                                        ).includes('Overdue')
                                        ? 'This quote has expired, please request a new one.'
                                        : `Expires on ${formatDate(
                                            request?.message_type_id?.expireInDate || currentTime,
                                            true
                                          )} | ${calculateDateDifference(request?.message_type_id?.expireInDate, currentTime, true)} left`
                                      : ' '}
                                  </span>
                                  <p>
                                    Reviewing and approving quotes on time keeps your project on track and ensures any
                                    changes you need are accounted for as soon as possible.
                                  </p>
                                </div>
                                <div className="qoute-buttons">
                                  {!request?.message_type_id?.isEdited ? (
                                    request.message_type_id.approverSign ? (
                                      <div className="signed-div">
                                        <button className={`edit-btn button-signed`}>Signed</button>
                                        <img src={request.message_type_id.approverSign.url} />
                                      </div>
                                    ) : (
                                      <>
                                        {hasPermission(userRole, 'add_qoute', memberPermission) &&
                                          editableRequest?.status != 'close' &&
                                          !editableRequest.isCanceled && (
                                            <button
                                              className="edit-btn"
                                              onClick={() => editQoute(request?.message_type_id?._id)}>
                                              Edit Quote
                                            </button>
                                          )}
                                        {editableRequest?.status != 'close' &&
                                          !editableRequest.isCanceled &&
                                          (!request?.message_type_id?.expireInDate ||
                                            !calculateDateDifference(
                                              request.message_type_id.expireInDate,
                                              currentTime,
                                              true
                                            ).includes('Overdue')) &&
                                          hasPermission(
                                            userRole,
                                            'approve_qoute',
                                            memberPermission,
                                            isInternalProject
                                          ) && (
                                            <button
                                              className="edit-btn"
                                              style={{
                                                width: 'fitContent',
                                                minWidth: '10px'
                                              }}
                                              onClick={() => handleApproveOpen(request?.message_type_id?._id)}>
                                              Approve and Sign
                                            </button>
                                          )}
                                      </>
                                    )
                                  ) : (
                                    ''
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    <div className={`chat-time ${userId == request.createdBy?._id ? 'me' : 'you'}`}>
                      {request?.createdBy?.fullName} {/* {activity.createdBy.email.split("@")[0]} -{" "} */}
                      {formatDateTime(request.createdDate)}
                    </div>
                  </div>
                </>
              ))}
            </>
          )
        )}
        {messagePageLoading && <div>{selectLoader(35)}</div>}
      </div>

      <ModalCenter
        extraClass={'updatedRequest-modal'}
        show={modals.requestModal}
        headerTitle={'Submit a Request'}
        // closeModal={() => {
        //   toggleModal('requestModal', false);
        // }}
        closeModal={() => {
          // call child logic instead
          document.dispatchEvent(new Event('requestModalClose'));
        }}>
        <RequestModal
          projectId={projectId}
          requestId={requestMsgId}
          closeModal={() => {
            updateCloseModal('requestModal');
          }}
          onCloseRequestModal={() => {
            toggleModal('requestModal', false);
          }}
        />
      </ModalCenter>

      {/* //forms for change request */}
      <SidebarModal
        extraClass={'edit-profile-modal'}
        show={modals.addQuoteModal}
        onHide={() => toggleModal('addQuoteModal', false)}
        headerTitle={'Quote'}>
        <AddQuoteModal
          projectId={projectId}
          changeReqId={orderQouteId || selectedReqId || parentId || requestId}
          qouteId={qouteId}
          closeModal={() => {
            updateCloseModal('addQuoteModal', false);
            setQouteRequired(false);
          }}
        />
      </SidebarModal>
      <ModalCenter
        extraClass={'updatedRequest-modal'}
        show={modals.changeOrderModal}
        headerTitle={'Edit Change Order'}
        closeModal={() => {
          toggleModal('changeOrderModal', false);
        }}>
        <ChangeOrderModal
          projectId={projectId}
          requestId={requestMsgId}
          setChangeReqId={setChangeReqId}
          setQouteRequired={setQouteRequired}
          closeModal={() => {
            if (isQouteRequired == true) {
              setQouteRequired(false);
              setModals((prevState) => ({
                ...prevState,
                addQuoteModal: true,
                changeOrderModal: false
              }));
            } else {
              updateCloseModal('changeOrderModal', false);
            }
          }}
        />
      </ModalCenter>

      {/* // forms for sign-off flow */}

      <ModalCenter
        extraClass={'updatedSignOff-modal'}
        show={modals.signOffModal}
        headerTitle={'Sign-off Request'}
        closeModal={() => {
          toggleModal('signOffModal', false);
        }}>
        <SignOffForm
          projectId={projectId}
          milestoneId={milestoneId}
          requestId={requestMsgId}
          isInternalProject={isInternalProject}
          closeModal={() => {
            updateCloseModal('signOffModal', false);
          }}
        />
      </ModalCenter>

      <ModalCenter
        extraClass={'signature-modal'}
        show={modals.signature}
        headerTitle={'Signature'}
        closeModal={() => {
          toggleModal('signature', false);
        }}>
        <SignatureModal
          requestId={qouteId || requestMsgId || requestId}
          setMilestoneId={setMilestoneId}
          openFeedback={handleFeedbackModal}
          isQouteApproval={isQouteApproval}
          optionId={optionId}
          closeModal={() => {
            updateCloseModal('signature', false);
          }}
        />
      </ModalCenter>
      <ModalCenter
        extraClass={'override-modal'}
        show={modals.overrideModal}
        closeModal={() => {
          toggleModal('overrideModal', false);
        }}
        headerTitle={'Override AI Decision'}>
        <OverrideModal
          overrideReasons={overrideReasons}
          requestId={selectedReqId || requestId}
          closeModal={() => {
            updateCloseModal('overrideModal', false);
            // setActiveTab('requestList');
          }}
        />
      </ModalCenter>
      <ModalCenter
        extraClass={'override-modal reject-modal'}
        show={modals.rejectReqModal}
        closeModal={() => {
          toggleModal('rejectReqModal', false);
        }}
        headerTitle={'Reject Request'}>
        <RejectRequestModal
          requestId={selectedReqId || requestId}
          closeModal={() => {
            updateCloseModal('rejectReqModal', false);
            // setActiveTab('requestList');
          }}
        />
      </ModalCenter>

      <ModalCenter
        extraClass={'feedback-modal'}
        show={modals.feedbackModal}
        closeModal={() => {
          toggleModal('feedbackModal', false);
        }}
        headerTitle={'Feedback'}>
        <FeedbackModal
          requestId={selectedReqId || requestId}
          milestoneId={milestoneId}
          closeModal={() => {
            updateCloseModal('feedbackModal', false);
            setActiveTab('requestList');
          }}
        />
      </ModalCenter>
      <ConfirmModal
        show={modals.closeConfirmModal}
        onHide={() => {
          toggleModal('closeConfirmModal', false);
        }}
        confirmationText={closeConfirmContent}
        handleAction={() => handleCloseReq(false)} // Pass the deletion logic here
        loading={loading}
        closeText="Yes"
      />
      <ConfirmModal
        show={modals.cancelConfirmModal}
        onHide={() => {
          toggleModal('cancelConfirmModal', false);
        }}
        confirmationText={cancelConfirmContent}
        handleAction={() => handleCloseReq(true)} // Pass the deletion logic here
        loading={loading}
        closeText="Yes"
      />

      <ConfirmModal
        show={modals.convertConfirmModal}
        onHide={() => {
          toggleModal('convertConfirmModal', false);
        }}
        confirmationText={convertConfirmContent}
        handleAction={handleCovertReq} // Pass the deletion logic here
        loading={loading}
        closeText={'Convert'}
      />
    </div>
  );
};

export default RequestDetails;
